<template lang='pug'>
  div
    .main
      #mapNode(:style='mapStyle')
</template>

<script>
import { mapGetters } from 'vuex'
import { expire } from '@/utils/auth'
export default {
  name: 'dashboard-home',
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
    this.$arcgis(({Map, Amap, ArcGISDynamicMapServiceLayer}) => {
      let map = new Map('mapNode', {
        // center: [116.800582, 23.503007],
        center: [116.7196177932, 23.366262020], // 信德华地址
        zoom: 15
      })
      const baselayer = new Amap()
      console.info('baselayer:', baselayer)
      map.addLayer(baselayer)
      // const layer = new ArcGISDynamicMapServiceLayer('http://218.17.45.99:6080/arcgis/rest/services/南洋自来水/MapServer')
      // map.addLayer(layer)
    })
  },
  computed: {
    ...mapGetters([
      'clientHeight'
    ]),
    mapStyle () {
      return {
        height: this.clientHeight - 60 + 'px'
      }
    }
  }
}
</script>

<style lang='sass' scoped>
</style>



// WEBPACK FOOTER //
// Home.vue?441066a5